import { AppBar, MenuItem, TextField, Toolbar, FormControlLabel, Switch, Tooltip, IconButton } from "@mui/material";
import { lensLogo, tekLogo } from "../assets";
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';

interface HeaderProps {
    autoSaveEnabled: boolean;
    handleAutoSaveToggle: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onOpenQuickSearch: () => void;
}

export const Header: React.FC<HeaderProps> = ({ autoSaveEnabled, handleAutoSaveToggle, onOpenQuickSearch }) => {
    const { t, i18n } = useTranslation();

    const changeLng = (e:any)=> {
        i18n.changeLanguage(e.target.value);
    }

    return (
        <AppBar component="nav" color="transparent" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar >
                <div className="flex align-center">
                    <img src={tekLogo} alt="" className="lens-logo" />
                    <img src={lensLogo} alt="" className="lens-logo" />
                </div>
                <div className="language-selector">
                    <TextField onChange={changeLng}
                        select value={i18n.language}
                        label={t("Language")}>
                        <MenuItem value={'en-US'}>English</MenuItem>
                        <MenuItem value={'fr'}>French</MenuItem>
                        {/* <MenuItem value={'es'}>Spanish</MenuItem> */}
                    </TextField>
                </div>
                <Tooltip title={t('Auto Save')}>
                <FormControlLabel
                    control={<Switch checked={autoSaveEnabled} onChange={handleAutoSaveToggle} />}
                    sx={{ marginLeft: 2 }}
                />
                </Tooltip>
                <Tooltip title={t('Quick Open (Ctrl/Cmd+K)')}>
                    <IconButton onClick={onOpenQuickSearch} className="quick-open-trigger">
                        <SearchIcon />
                    </IconButton>
                </Tooltip>
            </Toolbar>
        </AppBar >
    )
}
